import { COOKIE_POLICY_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[COOKIE_POLICY_MODULE_ID]: {
		moduleType: 'static',
		staticPageType: 'cookiePolicy',
	},
}
